// funcion acorta texto
export const funAcortarText = (size, text) => {
  if (text) {
    if (text.length > size) {
      return text.slice(0, size) + "...";
    } else return text;
  }
};

// Convierte un texto a sentence-case: primera letra en mayúscula y primera
// letra después de cada punto/signo también en mayúscula. El resto minúscula.
export const toSentenceCase = (text) => {
  if (!text || typeof text !== "string") return text;
  return text
    .toLowerCase()
    .replace(/(^\s*\p{L}|[.!?]\s*\p{L})/gu, (c) => c.toUpperCase());
};
